import { createReducer, on } from '@ngrx/store';
import * as actions from './se-side-patient-history.actions';
import { clone, setWith } from 'lodash-es';
import {
    seSidePatientHistoryInitialState,
    SeSidePatientHistoryState,
} from './se-side-patient-history.state';

export const seSidePatientHistoryReducer = createReducer(
    seSidePatientHistoryInitialState,
    on(actions.seSidePatientHistoryComponentSetPatient, (state, { formType, patientId }) => setPatient(state, formType, patientId)),
    on(actions.seSidePatientHistoryComponentNoResult, (state, { formType, message }) => setMessage(state, formType, message)),
    on(actions.seSidePatientHistoryComponentSetSelectedItem, (state, { formType, item }) => setSelectedItem(state, formType, item))
);

export const updatePatientHistoryState = (path: string, value: any, state: any) => setWith(clone(state), path, value, clone);

function setPatient(state: SeSidePatientHistoryState, formType: any, patientId:string): SeSidePatientHistoryState {
    return updatePatientHistoryState(`${formType}.patientId`, patientId,
        updatePatientHistoryState(`${formType}.message`, null,state));
}

function setSelectedItem(state: SeSidePatientHistoryState, formType: any, item: any): SeSidePatientHistoryState {
    return updatePatientHistoryState(`${formType}.selectedItem`, item,
        updatePatientHistoryState(`${formType}.message`, null, state));
}

function setMessage(state: SeSidePatientHistoryState, formType: any, message: string): SeSidePatientHistoryState {
    return updatePatientHistoryState(`${formType}.patientId`, null,
        updatePatientHistoryState(`${formType}.message`, message, state));
}

